import React from "react";
import { Link } from 'react-router-dom';

function PreviousPeriod({ url }){
    return (
        <Link to={url} className="next-previous-period" style={{marginRight: '15px'}}>{"<< Previous Period"}</Link>
    );
}

export default PreviousPeriod;